// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3s8RK","name":"ConsentHeader_name__3zht2","birthday":"ConsentHeader_birthday___WfAQ","skeleton":"ConsentHeader_skeleton__1Si8l"};